(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["info-popup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.currentScript.closest('dialog-component') || document.querySelector('dialog-component.info-popup[data-section-id]');
    if (!root) return;
    const mode = root.getAttribute('data-auto-open');
    if (!mode) return;
    const sectionId = root.getAttribute('data-section-id');
    const storageKey = 'ft-info-popup-' + sectionId;

    function alreadyShown() {
      try {
        if (mode === 'session') return sessionStorage.getItem(storageKey) === '1';
        if (mode === 'persistent') return localStorage.getItem(storageKey) === '1';
      } catch (e) {}
      return false;
    }

    function markShown() {
      try {
        if (mode === 'session') sessionStorage.setItem(storageKey, '1');
        else if (mode === 'persistent') localStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    function openDialog() {
      const dlg = root.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        markShown();
      }
    }

    if (mode === 'always') {
      requestAnimationFrame(openDialog);
    } else if (!alreadyShown()) {
      requestAnimationFrame(openDialog);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
